import { AttributeInput } from '@data/shopify/storefront/types'
import { LineItem } from '@lib/cart'
import { institutionIdAttributeKey, institutionNameAttributeKey } from './cart'

/**
 * Gets institution-related attributes.
 */
export const getInstitutionAttributes = (
  institutionId: string,
  institutionName: string,
) => {
  const attributes: AttributeInput[] = [
    {
      key: `_${institutionIdAttributeKey}`,
      value: institutionId,
    },
    {
      key: `_${institutionNameAttributeKey}`,
      value: institutionName,
    },
  ]

  return attributes
}

/**
 * Checks if all line items have correct institution ID and name attributes.
 */
export const validateLineItemInstitutionAttributes = (
  lineItems: LineItem[],
  institutionId: string,
) => {
  const institutionIdAttributeKeys = [
    institutionIdAttributeKey,
    `_${institutionIdAttributeKey}`,
  ]
  const institutionNameAttributeKeys = [
    institutionNameAttributeKey,
    `_${institutionNameAttributeKey}`,
  ]

  return lineItems.every((lineItem) => {
    const institutionIdAttribute = lineItem.attributes?.find((attribute) => {
      return institutionIdAttributeKeys.includes(attribute.key)
    })
    const institutionNameAttribute = lineItem.attributes?.find((attribute) => {
      return institutionNameAttributeKeys.includes(attribute.key)
    })

    const isValid =
      institutionIdAttribute?.value === institutionId &&
      !!institutionNameAttribute?.value

    return isValid
  })
}
